import { Stack as MuiStack } from "@mui/material"
import { ComponentProps } from "react"

import { uiskMuiSpacingMap, UiskSpacingProps } from "../utils/uiskMuiSpacingMap"

const Stack = (props: StackProps) => {
  const muiSpacingProps = uiskMuiSpacingMap(props)
  return <MuiStack {...props} {...muiSpacingProps} />
}

export type StackProps = Omit<
  ComponentProps<typeof MuiStack>,
  keyof UiskSpacingProps
> &
  UiskSpacingProps

export default Stack
